import { ActionType } from "../constants/likeAndComments";
import {
  postLikesApi,
  addCommentApi,
  getCommentsApi
} from "../../api/likeAndComments/likeAndComments";

export const addLikeDislikeAction = (data, refreshDataHandler) => dispatch => {
  return postLikesApi(data)
    .then(response => {
      return dispatch({
        type: ActionType.ADD_LIKE_DISLIKE,
        payload: response.data
      });
    })
    .then(() => {
      refreshDataHandler();
    })
    .catch(error => {
      dispatch({
        type: ActionType.ADD_LIKE_DISLIKE_ERRORS,
        payload: error.response
      });
    });
};

export const addCommentAction = (data, refreshCommentsHandler) => dispatch => {
  return addCommentApi(data)
    .then(response => {
      return dispatch({
        type: ActionType.ADD_COMMENT,
        payload: response.data
      });
    })
    .then(() => {
      refreshCommentsHandler();
    })
    .catch(error => {
      dispatch({
        type: ActionType.ADD_COMMENT_ERRORS,
        payload: error.response.data
      });
    });
};

export const getCommentsAction = (id, page = 1, per_page = 20) => dispatch => {
  return getCommentsApi(id, page, per_page)
    .then(
      dispatch({
        type: ActionType.GET_COMMENTS_START
      })
    )
    .then(response => {
      dispatch({
        type: ActionType.GET_COMMENTS_SUCCESS,
        payload: response.data.comments,
        id: id
      });
    })
    .catch(error => {
      dispatch({
        type: ActionType.GET_COMMENTS_SUCCESS,
        payload: error.response
      });
    });
};

export const writeCommentAction = value => dispatch => {
  return dispatch({
    type: ActionType.WRITE_COMMENT,
    payload: value
  });
};

export const deleteErrorsAction = () => dispatch => {
  return dispatch({
    type: ActionType.DELETE_ERRORS
  });
};
